import React from 'react';
import Header from './Header';
import Background from './Background';
import { GiReceiveMoney } from "react-icons/gi";
import { FaShoppingCart, FaBed, FaHeadset } from "react-icons/fa";
import './Home.css'; // Import the CSS file
import { Link } from 'react-router-dom';
import { FaLeaf } from 'react-icons/fa';
import { FaClipboardList } from "react-icons/fa6";
import { FaHouseChimneyWindow } from "react-icons/fa6";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import NewHeader from './NewHeader';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import Footer from './Footer';
import { BiSolidMessageRounded } from "react-icons/bi";
import {FaStore } from 'react-icons/fa';  // Other icons
import { GiHouse } from "react-icons/gi";
import { BiSolidMessageDetail } from "react-icons/bi";
import { FaLaptop } from "react-icons/fa";
import { ArrowRight, ShoppingCart, MessageCircle, Home, ClipboardList, Store, Laptop } from "lucide-react";


const videoList = [
  'https://th.bing.com/th?id=OIF.KgppQwruZu9XeeVktD5%2fnw&w=192&h=192&c=7&r=0&o=5&pid=1.7',
  'https://th.bing.com/th?id=OIF.77EX70Ev%2fMWGvscYeWecNw&w=162&h=180&c=7&r=0&o=5&pid=1.7',
  'https://th.bing.com/th?id=OIF.a54gXgHWJ4sqfLGdk%2bOV0Q&w=169&h=180&c=7&r=0&o=5&pid=1.7',
  'https://th.bing.com/th?id=OIF.X%2bHXI0KmOql9Jw5DoooNDg&w=189&h=189&c=7&r=0&o=5&pid=1.7',
  'https://th.bing.com/th?id=OIF.BPazz3mL%2bTxT3zQe5Py%2b1g&w=177&h=180&c=7&r=0&o=5&pid=1.7',
];


const carouselSettings = {

  
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  rtl: true,
  responsive: [
    {
      breakpoint: 1280,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 },
    },
  ],
};



const carouselSetting = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1280,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1 },
    },
  ],
};




function HomePage() {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate(); 
  const [notice, setNotice] = useState('');
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageContent, setMessageContent] = useState('');
  const [showWaiiona, setShowWaiiona] = useState(true); // State to show "Waiiona"
  const [descIndex, setDescIndex] = useState(0);

  const descriptions = [
    "Discover a world of products, book accommodation, and enjoy seamless online shopping. Your one-stop marketplace for everything!",
    "Shop electronics, fashion, home appliances, and more at unbeatable prices.",
    "Experience fast delivery, secure payments, and excellent customer service.",
    "Find exclusive deals and trending products every day on Waiiona.",
    "Your trusted Malawian eCommerce platform for all your needs."
  ];

  
   
  useEffect(() => {

    fetchProducts();
    const timer = setTimeout(() => {
      setShowWaiiona(false);
    }, 1000);
    return () => clearTimeout(timer); // Clean up the timer
   
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setDescIndex((prev) => (prev + 1) % descriptions.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`https://mybackend-new.onrender.com/products?search=${searchTerm}`);
      
      // Shuffle products to appear in random order
      const shuffledProducts = shuffleArray(res.data);
      
      setProducts(shuffledProducts);
     
    } catch (err) {
      console.error('Error fetching products:', err);
      
    }
  };


    
  const handleSendMessage = async () => {


      if(messageContent) {
    showNotice('Message sent');
   
try {

 await axios.post(
   'https://mybackend-new.onrender.com/feedback',
   {
     description: messageContent
   }
 
 );


 setMessageContent('');

 setTimeout(() => setNotice(''), 3000);
 
 setShowMessageModal(false);
} catch (err) {
 console.error('Error sending message:', err);
}

   }

   else{
    setShowMessageModal(false);
   }
};





const showNotice = (message) => {
  setNotice(message);
  
  // Set a timeout to clear the notice after 3 seconds
  setTimeout(() => {
    setNotice('');
  }, 5000); // 3000 milliseconds = 3 seconds
};




   // Fisher-Yates shuffle algorithm to randomize the order of products
  const shuffleArray = (array) => {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  };
  


  const filteredProducts = products.filter(product =>
    product.name
  );


  const handleSearchSubmit = (e) => {
    e.preventDefault();
    navigate(`/marketPage?search=${searchTerm}`); // Redirect to Market with search term
  };







  return (
     <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        <NewHeader />
      <div className="bg-white bg-opacity-70 absolute inset-0 -z-10"></div>
      <div className="relative z-10">
      
        {showWaiiona && (
          <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
            <img
              src="/logo.png"
              alt="Waiiona Logo"
              className="w-32 h-32 border-4 border-gray-300 rounded-2xl animate-pulse"
            />
          </div>
        )}

       {/* Hero Section */}
     <section className="relative bg-gradient-to-r from-primary to-primary/80 text-primary-foreground overflow-hidden text-white">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop')] bg-cover bg-center"></div>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative container mx-auto px-4 py-20 lg:py-32">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h1 className="text-4xl md:text-6xl font-bold leading-tight animate-fade-in">
              Go Smart Buying with{" "}
              <span className="bg-gradient-to-r from-orange-400 to-yellow-400 bg-clip-text text-transparent">
                Waiiona
              </span>
            </h1>
            
            <p className="text-lg md:text-xl text-primary-foreground/90 max-w-2xl mx-auto transition-all duration-700">
              {descriptions[descIndex]}
            </p>

             <form onSubmit={handleSearchSubmit} className="w-full max-w-xl flex relative ">
            
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                required
                placeholder="What are you looking for?"
                className="flex-1 h-14 pl-6 pr-32 text-gray-700 border-2 border-gray-700 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-[#4682B4] bg-white"
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 h-10 px-8 text-white bg-gray-700 rounded-full font-semibold shadow"
              >
                Search
              </button>
            </form>

            {/* Process Steps */}
            <div className="flex justify-center gap-8 mt-12">
              <div className="flex flex-col items-center group">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                  <ClipboardList className="w-8 h-8" />
                </div>
                <span className="text-sm font-semibold">Order</span>
              </div>
              <div className="flex flex-col items-center group">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                  <ShoppingCart className="w-8 h-8" />
                </div>
                <span className="text-sm font-semibold">Pay</span>
              </div>
              <div className="flex flex-col items-center group">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                  <Store className="w-8 h-8" />
                </div>
                <span className="text-sm font-semibold">Collect</span>
              </div>
            </div>

          <div className="flex justify-center">
  <button size="lg" className="flex bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:scale-105 transition-all justify-center items-center">
    Join Free <ArrowRight className="ml-2 w-5 h-5" />
  </button>
</div>

          </div>
        </div>
      </section>
        {/* FEATURE HIGHLIGHTS */}
        <div className="max-w-5xl mx-auto mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 px-4">
          <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center hover:shadow-lg transition">
            <FaStore className="text-blue-700 text-3xl mb-2" />
            <h3 className="font-bold text-lg mb-1">Vast Product Variety</h3>
            <p className="text-gray-600 text-sm text-center">Thousands of products across categories, all in one place.</p>
          </div>
          <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center hover:shadow-lg transition">
            <FaShoppingCart className="text-orange-500 text-3xl mb-2" />
            <h3 className="font-bold text-lg mb-1">Easy Shopping</h3>
            <p className="text-gray-600 text-sm text-center">User-friendly experience for effortless browsing and buying.</p>
          </div>
         <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center hover:shadow-lg transition">
  <FaLaptop className="text-green-600 text-3xl mb-2" />
  <h3 className="font-bold text-lg mb-1">Shop Electronics</h3>
  <p className="text-gray-600 text-sm text-center">Browse the latest gadgets, smartphones, accessories, and more.</p>
</div>

        </div>

        {/* MARKET CTA */}
        <div className="flex items-center justify-center mt-12">
          <Link to="/marketPage">
            <div className="border border rounded-2xl p-6 flex items-center gap-4 bg-gray-700 from-blue-700 to-blue-900 hover:shadow-xl hover:scale-105 transition-all duration-300">
              <FaStore className="text-white text-3xl" />
              <p className="text-white text-xl font-semibold">Explore Our Market</p>
            </div>
          </Link>
        </div>

        {/* PRODUCT CAROUSEL */}
        <div className="max-w-6xl mx-auto mt-14 px-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Featured Products</h2>
          <Slider {...carouselSetting} className="bg-white rounded-xl shadow-md py-6 px-2">
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-white border border-gray-100 rounded-xl p-4 mx-2 w-[180px] flex-shrink-0 hover:shadow-lg transition"
              >
                <div className="aspect-square overflow-hidden rounded-lg bg-gray-50 mb-3 flex items-center justify-center">
                  <img
                    src={`${product.picture}`}
                    alt={product.name}
                    className="w-full h-full object-contain transition-transform duration-200 group-hover:scale-105"
                  />
                </div>
                <h2 className="text-sm font-semibold text-gray-800 line-clamp-2 mb-1">{product.name}</h2>
                <div className="flex items-center space-x-2 text-base">
                  <span className="font-bold text-blue-700">MK{product.price.toLocaleString()}</span>
                  {product.oldPrice && (
                    <span className="text-gray-400 line-through text-xs">
                      MK{product.oldPrice.toLocaleString()}
                    </span>
                  )}
                </div>
                <div className="mt-1 flex items-center space-x-1 text-yellow-400 text-xs">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span className="text-gray-300">★</span>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* TRENDING PRODUCTS */}
        <div className="max-w-6xl mx-auto mt-16 px-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Trending Products</h2>
          <Slider {...carouselSettings} className="bg-white rounded-xl shadow-md py-6 px-2">
            {filteredProducts.map((product) => (
              <div key={product.id} className="rounded-xl p-3 hover:shadow-lg transition">
                <img
                  src={`${product.picture}`}
                  alt={product.name}
                  className="w-full h-40 object-cover rounded-lg mb-2"
                />
                <h2 className="text-xs font-bold text-gray-800">{product.name}</h2>
                <p className="text-xs font-semibold text-blue-700">MK{product.price}</p>
              </div>
            ))}
          </Slider>
        </div>


        {/* FEEDBACK BUTTON */}
        <button
          onClick={() => setShowMessageModal(true)}
          className="fixed bottom-6 right-6 bg-orange-500  from-blue-700 to-blue-500 text-white rounded-full shadow-lg hover:scale-105 focus:outline-none z-50 flex flex-col items-center px-3 py-2"
        >
          <BiSolidMessageDetail size={36} />
     
        </button>

        {/* FEEDBACK MODAL */}
        {showMessageModal && (
          <div className="fixed inset-0 p-4 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-lg">
              <h2 className="text-2xl font-bold mb-4 text-blue-700">Send Feedback</h2>
              <textarea
                value={messageContent}
                onChange={(e) => setMessageContent(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400"
                rows="3"
                placeholder="Type your feedback here..."
                maxLength="200"
                required
              ></textarea>
              <div className="flex justify-end gap-3 mt-4">
                <button
                  onClick={handleSendMessage}
                  className="bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-600"
                >
                  Send
                </button>
                <button
                  onClick={() => setShowMessageModal(false)}
                  className="bg-gray-300 text-gray-800 px-6 py-2 rounded-lg font-semibold hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
              {notice && <p className="text-green-600 mt-3 text-center">{notice}</p>}
            </div>
          </div>
        )}

        {/* FOOTER & FINAL MESSAGE */}
        <div className="max-w-4xl mx-auto mt-16 mb-8 px-4">
          <p className="text-center text-lg text-gray-700 font-medium">
            Discover the best products and enjoy the best services we offer. We are committed to providing top-notch customer satisfaction and quality products.
          </p>

        </div>
        <Footer />
      </div>
    </div>
  );
}

export default HomePage;
